module.exports = __webpack_public_path__ + "img/BR.08847ac7.jpg";